export enum StepperLabelEnum {
  Welcome = 'Welcome', UpdateInfo = 'Verify Info', Edition = 'Edition', Success = 'Success', Prime = 'Prime',
                       Pricing = 'Pricing', Confirmation = 'Confirmation', Quotes = 'Quotes', Finalize = 'Finalize',
}
